import 'react-datepicker/dist/react-datepicker.css';
import DatePicker from 'react-datepicker';
import iconChevronDown from '../img/icon-chevron-black-down.png';
import iconXBlack from '../img/icon-x-black.png';
import Modal from 'react-modal';
import PropTypes from 'prop-types';
import React, { Component } from 'react';


const DATEPICKER_POPPER_CLASS = 'list-filter-datepicker-popper';


export default class ListFilter extends Component{
  state = {
    startDate: null,
    endDate: null,
  };


  handleChangeStart = event => {
    const {handleStartDate} = this.props;

    handleStartDate(event);
    this.setState({
      startDate: event,
    });
  };
  handleChangeEnd = event => {
    const {handleEndDate} = this.props;

    handleEndDate(event);
    this.setState({
      endDate: event,
    });
  };
  handleClearAll = () => {
    this.props.handleClearFilter();
    if(this.props.startDate === undefined){
      this.setState({
        startDate: null,
        endDate: null,
      });
    }
  };
  getStartDate = () => (
    this.props.startDate !== undefined ? this.props.startDate : this.state.startDate
  );
  getEndDate = () => (
    this.props.endDate !== undefined ? this.props.endDate : this.state.endDate
  );


  renderCategories = () => {
    if(!this.props.categories) return null;

    const {categories, handleCategoryFilter, selectedCategory} = this.props;

    return (
      <div className="list-filter-container">
        <div className="list-filter-title">Event Category</div>
        <div className="list-filter-items">
          {categories.map(item => (
            <div className="checkbox-item-container" key={item.id}>
              <input checked={selectedCategory.includes(item.id)}
                     id={`input-category-${item.id}`}
                     onChange={() => handleCategoryFilter(item.id, 'category')}
                     type="checkbox"/>
              <label htmlFor={`input-category-${item.id}`}>{item.title}</label>
            </div>
          ))}
        </div>
      </div>
    );
  };
  renderPrograms = () => {
    if(!this.props.programs) return null;

    const {programs, handleCategoryFilter, selectedProgram} = this.props;

    return (
      <div className="list-filter-container">
        <div className="list-filter-title">Programs</div>
        <div className="list-filter-items">
          {programs.map(item => (
            <div className="checkbox-item-container" key={item.id}>
              <input checked={selectedProgram.includes(item.id)}
                     id={`input-program-${item.id}`}
                     onChange={() => handleCategoryFilter(item.id, 'program')}
                     type="checkbox"/>
              <label htmlFor={`input-program-${item.id}`}>{item.title}</label>
            </div>
          ))}
        </div>
      </div>
    );
  };
  renderDateRange = () => (
    <div className="list-filters-date-container">
      <div className="lister-filter-date-wrapper">
        <div className="lister-filter-date-label">From</div>
        <DatePicker className="list-filter-date-picker"
                    popperClassName={DATEPICKER_POPPER_CLASS}
                    selected={this.getStartDate()}
                    onChange={this.handleChangeStart}/>
        <img alt="" className="date-button__icon" src={iconChevronDown}/>
      </div>
      <div className="lister-filter-date-wrapper">
        <div className="lister-filter-date-label">To</div>
        <DatePicker className="list-filter-date-picker"
                    popperClassName={DATEPICKER_POPPER_CLASS}
                    selected={this.getEndDate()}
                    startDate={this.getStartDate()}
                    onChange={this.handleChangeEnd}/>
        <img alt="" className="date-button__icon" src={iconChevronDown}/>
      </div>
    </div>
  );
  renderTypes = () => {
    if(!this.props.types) return null;

    const {types, handleCategoryFilter, selectedType} = this.props;

    return (
      <div className="list-filter-container">
        <div className="list-filter-title">Type</div>
        <div className="list-filter-items">
          {types.map(item => (
            <div className="checkbox-item-container" key={item.id}>
              <input checked={selectedType.includes(item.id)}
                     id={`input-type-${item.id}`}
                     onChange={() => handleCategoryFilter(item.id, 'type')}
                     type="checkbox"/>
              <label htmlFor={`input-type-${item.id}`}>{item.title}</label>
            </div>
          ))}
        </div>
      </div>
    );
  };
  renderListModal = () => {
    const {title, modalOpen, handleModalHide, disableDate} = this.props;

    return (
      <Modal isOpen={modalOpen}
             className="list-modal"
             overlayClassName="list-modal-overlay"
             contentLabel={title}
             onRequestClose={handleModalHide}>
        <div className="list-modal-header">
          <div className="list-filters-title">
            {title}
            <button type="button"
                    className="list-filter-clear-link"
                    onClick={this.handleClearAll}>
              Clear All
            </button>
          </div>
          <button type="button"
                  aria-label="Close"
                  className="modal-close-button"
                  onClick={handleModalHide}>
            <img alt="" className="button__icon" src={iconXBlack}/>
          </button>
        </div>
        <div className="list-filters-modal">
          {!disableDate && this.renderDateRange()}
          {this.renderCategories()}
          {this.renderPrograms()}
        </div>
        <div className="filter-modal-footer">
          <button type="button"
                  className="filter-modal-footer-button"
                  onClick={handleModalHide}>
            Cancel
          </button>
          <button type="button"
                  className="filter-modal-footer-button filter-modal-footer-button--done"
                  onClick={handleModalHide}>
            Done
          </button>
        </div>
      </Modal>
    );
  };
  render(){
    const {title, disableDate} = this.props;
    return (
      <>
        <div className="container container--coupling">
          <div className="list-filters">
            <div className="list-filters-title">
              {title}
              <button type="button"
                      className="list-filter-clear-link"
                      onClick={this.handleClearAll}>
                Clear All
              </button>
            </div>
            {!disableDate && this.renderDateRange()}
            {this.renderCategories()}
            {this.renderTypes()}
            {this.renderPrograms()}
          </div>
          {this.renderListModal()}
        </div>
      </>
    );
  }
}


ListFilter.propTypes = {
  categories: PropTypes.array,
  disableDate: PropTypes.bool,
  handleCategoryFilter: PropTypes.func,
  handleClearFilter: PropTypes.func,
  endDate: PropTypes.instanceOf(Date),
  handleEndDate: PropTypes.func,
  handleModalHide: PropTypes.func,
  handleStartDate: PropTypes.func,
  startDate: PropTypes.instanceOf(Date),
  list: PropTypes.array,
  modalOpen: PropTypes.bool,
  programs: PropTypes.array,
  selectedCategory: PropTypes.array,
  selectedProgram: PropTypes.array,
  selectedType: PropTypes.array,
  title: PropTypes.string,
  types: PropTypes.array,
};
